import { type UUID } from 'crypto';
import dayjs, { type Dayjs } from 'dayjs';

import { parsePhone } from '@deepidoo/deesplay/utils';

export enum ReportStatus {
    CLOSED = 'CLOSED',
    IN_PROGRESS = 'IN_PROGRESS',
    NON_REPRODUCTIBLE = 'NON_REPRODUCTIBLE',
    PENDING = 'PENDING',
    RESOLVED = 'RESOLVED',
    WONT_FIX = 'WONT_FIX'
};

export enum ReportCategory {
	BUG = 'BUG',
	DESIGN = 'DESIGN',
	QUESTION = 'QUESTION',
	REQUEST = 'REQUEST',
	WORDING = 'WORDING'
};

export interface ReportSettings {
    browser?: string;
    os?: string;
    width?: number;
    height?: number;
};

export class Report {
    public id: UUID;
    public status: ReportStatus;
    public category: ReportCategory;
    public title: string;
    public description: string;
    public pageUrl: string;
    public screenshotUrl: string;
    public userId: number;
    public firstname: string;
    public lastname: string;
    public email?: string;
    public phone?: string;
    public phoneCountry?: string;
    public client: string;
    public organization: string;
    public settings: ReportSettings;
    public createdAt: Dayjs;

    constructor(dto: ReportDTO) {
        const { phone, phoneCountry } = parsePhone(dto.phone, dto.phoneCountry);

        this.id = dto.id;
        this.status = dto.status;
        this.category = dto.category;
        this.title = dto.title;
        this.description = dto.description;
        this.pageUrl = dto.pageUrl;
        this.screenshotUrl = dto.screenshotUrl;
        this.userId = dto.userId;
        this.firstname = dto.firstname;
        this.lastname = dto.lastname;
        this.email = dto.email;
        this.phone = phone;
        this.phoneCountry = phoneCountry;
        this.client = dto.client;
        this.organization = dto.organization;
        this.settings = { ...dto.settings };
        this.createdAt = dayjs.unix(+dto.createdAt / 1000);
    }
}

export interface ReportDTO {
    id: UUID;
    status: ReportStatus;
    category: ReportCategory;
    title: string;
    description: string;
    pageUrl: string;
    screenshotUrl: string;
    userId: number;
    firstname: string;
    lastname: string;
    email?: string;
    phone?: string;
    phoneCountry?: string;
    client: string;
    organization: string;
    settings: ReportSettings;
    createdAt: number;
};

export interface CreateReportDTO {
    category: ReportCategory;
    title: string;
    description: string;
    pageUrl: string;
    userId: number;
    firstname: string;
    lastname: string;
    email?: string;
    phone?: string;
    phoneCountry?: string;
    client: string;
    organization: string;
    settings: ReportSettings;
};

export interface UpdateReportDTO {
    id: UUID;
    status: ReportStatus;
};